<!-- Icon -->
<script lang="ts" setup>
    import { IconTypes, IconAnimation, DisplayStyle, HoverCursorTypes, TextDisplayStyle, IconFamily } from '../Enums/UiEnums';
    import { computed, ref } from 'vue';
    import { bootstrapPaddingLeftClass, bootstrapPaddingRightClass, BootstrapPaddingValue, bootstrapTextClass, hoverCursorStyle, iconClass } from '../lib/StyleHelpers';
    import XSpan from './HtmlWrapper/XSpan.vue';
import MaterialSymbolsIcon from './Icons/MaterialSymbolsIcon.vue';

    const props = withDefaults(defineProps<{
        icon?: IconTypes,
        displayStyle?: DisplayStyle | TextDisplayStyle,
        class?: string | string[],
        title?: string,
        hoverCursor?: HoverCursorTypes,
        clickIcon?: IconTypes,
        animation?: IconAnimation,
        startingPadding?: BootstrapPaddingValue,    // Add padding to the starting of the icon
        endingPadding?: BootstrapPaddingValue,      // Add padding to the end of the icon
        iconFamily?: IconFamily                     // Default is FontAwesome    
    }>(), {
        displayStyle: DisplayStyle.Primary,
        resetClick: false
    });

    const hasClicked= ref<boolean>(false); 

    const emit = defineEmits<{
        click: [evt: MouseEvent]
    }>();

    const iconEleClass = computed<string[]>(() => {   
        const classes = [
            iconFamilyClass.value ?? "", 
            bootstrapTextClass(props.displayStyle) ?? "",
            props.animation ?? "",
            bootstrapPaddingLeftClass(props.startingPadding) ?? "",
            bootstrapPaddingRightClass(props.endingPadding) ?? "",
        ];

        if (props.class)
        {
            if (typeof(props.class) === "string")
                classes.push(props.class);
            else
            classes.push(...props.class);
        } 

        return classes;
    });

    const iconFamilyClass = computed(() => {
        if (useMaterial.value)
            return;
        return iconClass(iconDisplay.value);
    });

    const iconDisplay = computed<IconTypes | undefined>(() => {
        return (hasClicked.value && props.clickIcon) ? props.clickIcon : props.icon;
    });

    async function iconClick(evt: MouseEvent) {             
        hasClicked.value = true;
        emit('click', evt);
    }

    const useMaterial = computed<boolean>(() => IconFamily.Material === props.iconFamily );
</script>

<template>
    <XSpan :title="props.title" @click="evt => iconClick(evt)" :style="hoverCursorStyle(props.hoverCursor)">
        <em :class="iconEleClass" v-if="!useMaterial"></em>
        <MaterialSymbolsIcon v-if="useMaterial" :icon="props.icon" :class="iconEleClass" />
    </XSpan>
</template>